import BaseService from "@/shared/base.service";

import { useAlertStore } from "@/stores/alert.store";

export interface NotificationEmailsData {
  account_email: string;
  notification_emails: string[];
}

export class AccountService {
  static async GetNotificationEmails(): Promise<NotificationEmailsData | null> {
    try {
      const response = await BaseService.get<{ data: NotificationEmailsData }>(
        "notification_emails"
      );

      return response?.data ?? null;
    } catch (error) {
      console.error("Error in GetNotificationEmails:", error);
      return null;
    }
  }

  static async UpdateNotificationEmails(
    emails: string[]
  ): Promise<string[] | null> {
    try {
      const response = await BaseService.put<{
        data: { notification_emails: string[] };
      }>("notification_emails", { notification_emails: emails });

      if (response) {
        useAlertStore().show(
          "success",
          "E-mails de notificação atualizados com sucesso."
        );
      }

      return response?.data?.notification_emails ?? null;
    } catch (error) {
      console.error("Error in UpdateNotificationEmails:", error);
      return null;
    }
  }
}
